import React, {Component} from 'react'
import propTypes from 'prop-types'
import {connect} from 'react-redux'
import {get, includes, isEmpty, isNil} from 'lodash'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Popover from '@material-ui/core/Popover'
import iconNames from 'theme/icons'
import theme from 'theme/index'
import themeVars from 'theme/themeVars'
import QuoteItemPivotTable from '../../containers/quoteItemPivotTable'
import QuotePivotTable from '../../containers/quotePivotTable'
import Button from '../../components/button'
import Placeholder from '../../components/placeholder'
import QuotesTotal from 'components/quotesTotal'
import QuotingFilterSidebar from 'components/quotingFilterSidebar'
import Icon from '../../components/icon'
import {quotingContextSelectorOrderItemsPivotTableKey} from 'reducers/quotingContext/selector'
import {requestData} from 'actions/pivotTable'
import {
  initialiseFindQuotesDialog,
  quoteFinderSelectQuote,
  quoteSelectorToggleItems,
  quoteSelectorUpdateFilters,
} from 'actions/quoting'
import {getIncludeFullyDelivered} from "selectors/deliveries"
import {getAllRows, getAllSelectedRows} from 'selectors/pivotTable'
import {getQuotingSelector} from 'selectors/quotes'
import {prefix} from 'helpers/component'
import {areAllRowsSelected} from 'helpers/pivotTable'
import {trackEvent} from 'helpers/tracking'
import './quoteFinder.scss'
import {onCanSelectOrderItem} from "helpers/orders"
import {getUser} from "selectors/auth"

const getClass = prefix('quoteFinder-')

const getStyles = () => {
  return {
    allRevisionsCheck: {
      flexShrink: 0,
      margin: '10px 5px 0 0',
      whiteSpace: 'nowrap',
      width: 120,
    },
    lineItemsCheck: {
      width: 200,
      marginTop: 5,
      marginLeft: 0,
    },
    selectedRow: {
      backgroundColor: theme.palette.primary1LightColor,
    },
  }
}

class QuoteFinder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedItems: [],
    }

    this.updateFilters = this.props.onUpdateFiltersFromDeliveries || this.props.onUpdateFilters
  }

  componentDidMount = () => {
    if (this.props.visible) {
      this.onLoad()
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.visible && this.props.visible)
      this.onLoad()
  }

  onLoad = () => {
    this.setState({selectedItems: []})
    const {onLoadQuotes, onInitialise, orderPivotTableKey, statusOptions} = this.props
    onInitialise(statusOptions)
    onLoadQuotes(orderPivotTableKey)
  }

  onToggleLineItems = (e, showLineItems) => {
    trackEvent('Quote Finder', 'Clicked on preview line items', 'Preview Line Items')

    const {selectedOrderId, onToggleLineItems, onLoadItems} = this.props
    onToggleLineItems(showLineItems)

    if (!isNil(selectedOrderId))
      onLoadItems()
  }

  onQuoteSelect = (selectedQuote) => {
    const {showLineItems, onLoadItems, onQuoteSelect} = this.props
    this.setState({
      selectedItems: [],
    })

    const orderId = get(selectedQuote, 'id', null)
    onQuoteSelect(orderId)

    if (showLineItems)
      onLoadItems(orderId)
  }

  onSelectItem = (item) => {
    const {selectLineItems} = this.props
    if (selectLineItems) {
      let {selectedItems} = this.state
      if (selectedItems.indexOf(item.id) >= 0) {
        selectedItems = selectedItems.filter(i => i !== item.id)
      } else {
        selectedItems = [...selectedItems, item.id]
      }
      this.setState({selectedItems})
    }
  }

  onClose = () => {
    //true argument hide the repeat quote field from the form if there is no current value
    const {selectedOrderId, onClose} = this.props
    const hideRepeatQuoteField = !selectedOrderId && true
    onClose(hideRepeatQuoteField)
  }

  getSelectedOrder = () => {
    const {selectedOrderId, allOrders} = this.props
    return isNil(selectedOrderId) || isEmpty(allOrders)
      ? null
      : allOrders.find(item => item.id === selectedOrderId)
  }

  onSubmit = () => {
    const {selectedOrderId, selectLineItems, onSubmit, onClose, selectedItems} = this.props

    if (!isEmpty(selectLineItems)) {
      onClose()
      onSubmit(selectedItems, this.getSelectedOrder())
    } else if (selectedOrderId) {
      onClose()
      onSubmit(selectedOrderId, this.getSelectedOrder())
    }
  }

  isSubmitDisabled = (selectedOrderId, selectedItems, selectLineItems) => {
    return selectLineItems
      ? isEmpty(selectedItems)
      : isNil(selectedOrderId)
  }

  getPreviewLineItems = (allowLineItemsToggle, showLineItems, styles) => {
    return allowLineItemsToggle
      ? (
        <FormControlLabel
          control={<Checkbox checked={showLineItems} onChange={this.onToggleLineItems}/>}
          label={'Preview Line Items'}
          style={styles.lineItemsCheck}
        />
      )
      : <p/>
  }

  render = () => {
    const {
      user,
      anchorElement,
      visible,
      title,
      showLineItems,
      allowLineItemsToggle,
      selectLineItems,
      selectedItems,
      submitLabel,
      selectedOrderId,
      onClose,
      total,
      canSelectOrderItems,
      allOrderItems,
      allSelectedOrderItems,
      onCopyOrderItem,
      onSelectAllRows,
      onDeSelectAllRows,
      onToggleSelectedRow,
      onUpdateFiltersFromDeliveries,
      statusOptions,
      dateOptions,
      allowAllRevisions,
      allowIncludeFullyScheduled,
      orderPivotTableKey,
      presetType,
      allowIncludeFullyDelivered,
    } = this.props

    if (anchorElement === null) return <div/>
    const styles = getStyles()

    let items
    if (showLineItems) {
      if (selectedOrderId) {
        items = (
          <div className={getClass('quote-items-table')}>
            <QuoteItemPivotTable
              stateKey={quotingContextSelectorOrderItemsPivotTableKey}
              onQuoteItemSelect={this.onSelectItem}
              listEntityClass={null}
              rowStyle={(item) =>
                selectLineItems && includes(selectedItems, item.id)
                  ? styles.selectedRow
                  : null
              }
              showHeader={false}
              groupingAllowed={false}
              pagingAllowed={false}
              stickyTop={0}
              canSelectRows={canSelectOrderItems}
              onCanSelect={item => onCanSelectOrderItem(user, item)}
              areAllRowsSelected={areAllRowsSelected(allOrderItems, allSelectedOrderItems)}
              exportingAllowed={false}
              onCopyOrderItem={onCopyOrderItem}
              onSelectAllRows={onSelectAllRows}
              onDeSelectAllRows={onDeSelectAllRows}
              onToggleSelectedRow={onToggleSelectedRow}
              showSubData={!canSelectOrderItems}
            />
          </div>
        )
      } else {
        items = (
          <div className={getClass('quote-items-table')}>
            <Placeholder
              messageTitle={'Line Items'}
              messageDescription={'Please select a quote above'}
              messageIcon={iconNames.order}/>
          </div>
        )
      }
    }

    const lineItemsCheck = this.getPreviewLineItems(allowLineItemsToggle, showLineItems, styles)
    const isSubmitDisabled = this.isSubmitDisabled(selectedOrderId, selectedItems, selectLineItems)

    return (
      <Popover
        key={'quote-finder-popover'}
        open={visible}
        onClose={onClose}
        anchorReference="none"
        style={{zIndex: 1000}}
        classes={{
          paper: (
            visible
              ? getClass(['popover', 'hide-scroll'])
              : getClass('popover')
          ),
        }}
        onClick={(e) => e.stopPropagation()}
        disableRestoreFocus={true}>
        <div className={getClass('container')}>
          <div className={getClass('header')}>
            {title}
            <div className={getClass('close')} onClick={this.onClose.bind(this)}>
              <Icon name="close" color={themeVars.palette.whiteColor}/>
            </div>
          </div>
          <div className={'wrapper'}>
            <QuotingFilterSidebar
              statusOptions={statusOptions}
              dateOptions={dateOptions}
              allowAllRevisions={allowAllRevisions}
              allowIncludeFullyScheduled={allowIncludeFullyScheduled}
              allowIncludeFullyDelivered={allowIncludeFullyDelivered}
              onUpdateFiltersFromDeliveries={onUpdateFiltersFromDeliveries}
              presetType={presetType}
              pivotTableKey={orderPivotTableKey}
            />
            <div className={'quote-pivot-table-wrapper'}>
              <div className={showLineItems
                ? getClass(['quotes-table', 'quotes-table-with-items'])
                : getClass('quotes-table')}>
                <QuotePivotTable
                  stateKey={orderPivotTableKey}
                  stickyTop={0}
                  filters={{}}
                  visibleFilters={{}}
                  onUpdateFilters={this.updateFilters}
                  onQuoteSelect={this.onQuoteSelect}
                  rowStyle={order => (selectedOrderId && order.id === selectedOrderId)
                    ? styles.selectedRow
                    : null
                  }
                  showHeader={true}
                  groupingAllowed={true}
                  exportingAllowed={false}
                  fullHeight={true}
                  footerRight={<QuotesTotal totalPrice={total}/>}
                />
              </div>
              {items}
            </div>
          </div>

          <div className={getClass('footer')}>
            {lineItemsCheck}
            <Button
              primary={true}
              label={submitLabel}
              disabled={isSubmitDisabled}
              onClick={this.onSubmit}
            />
          </div>
        </div>
      </Popover>
    )
  }
}

QuoteFinder.propTypes = {
  user: propTypes.object,
  statusOptions: propTypes.array,
  onInitialise: propTypes.func,
  presetType: propTypes.string,
  dateOptions: propTypes.array,
  allowAllRevisions: propTypes.bool,
  allowIncludeFullyScheduled: propTypes.bool,
  allowIncludeFullyDelivered: propTypes.bool,
  submitLabel: propTypes.string.isRequired,
  anchorElement: propTypes.object,
  title: propTypes.string,
  visible: propTypes.bool,
  selectedItems: propTypes.array,
  allowLineItemsToggle: propTypes.bool,
  selectLineItems: propTypes.bool,
  allOrders: propTypes.array,
  onSubmit: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
  canSelectOrderItems: propTypes.bool,
  areAllOrderItemsSelected: propTypes.bool,
  selectedOrderId: propTypes.number,
  showLineItems: propTypes.bool,
  total: propTypes.number,
  allOrderItems: propTypes.array,
  allSelectedOrderItems: propTypes.array,
  onLoadQuotes: propTypes.func,
  onLoadItems: propTypes.func,
  onQuoteSelect: propTypes.func,
  onUpdateFilters: propTypes.func,
  onToggleLineItems: propTypes.func,
  onCopyOrderItem: propTypes.func,
  onSelectAllRows: propTypes.func,
  onDeSelectAllRows: propTypes.func,
  onToggleSelectedRow: propTypes.func,
  onUpdateFiltersFromDeliveries: propTypes.func,
  orderPivotTableKey: propTypes.string,
}

QuoteFinder.defaultProps = {
  statusOptions: [],
  dateOptions: [],
  allowAllRevisions: true,
  allowIncludeFullyScheduled: false,
  allowIncludeFullyDelivered: false,
  visible: false,
  title: 'Find A Quote',
  showLineItems: false,
  allowLineItemsToggle: true,
  allowLineItemsSelect: false,
  canSelectOrderItems: false,
  areAllOrderItemsSelected: false,
  allOrderItems: [],
  allSelectedOrderItems: [],
}

const mapStateToProps = (state, ownProps) => {
  const {selectedOrderId, total} = getQuotingSelector(state)
  return {
    user: getUser(state),
    selectedOrderId,
    total,
    showLineItems: get(ownProps, 'showLineItems', state.quotingContext.selector.showLineItems),
    allOrders: getAllRows(state, ownProps.orderPivotTableKey),
    allOrderItems: getAllRows(state, quotingContextSelectorOrderItemsPivotTableKey),
    allSelectedOrderItems: getAllSelectedRows(state, quotingContextSelectorOrderItemsPivotTableKey),
    includeFullyDelivered: getIncludeFullyDelivered(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  onInitialise: (statusOptions) => dispatch(initialiseFindQuotesDialog(statusOptions)),
  onLoadQuotes: (stateKey) => dispatch(requestData(stateKey)),
  onLoadItems: () => dispatch(requestData(quotingContextSelectorOrderItemsPivotTableKey)),
  onQuoteSelect: (orderId) => dispatch(quoteFinderSelectQuote(orderId)),
  onUpdateFilters: (filters) => dispatch(quoteSelectorUpdateFilters(filters)),
  onToggleLineItems: (showLineItems) => dispatch(quoteSelectorToggleItems(showLineItems)),
})

export default connect(mapStateToProps, mapDispatchToProps)(QuoteFinder)
